import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import {
  saveAuthorization,
  clearAuthorization,
} from '../../actions/authorization-actions.js';
import { SigninUser } from '../../mutations/SigninUser';
import View from './View';

const mapDispatchToProps = (dispatch) => ({
  saveAuthorization: (token, role) => {
    dispatch(saveAuthorization(token, role));
  },
  clearAuthorization: () => {
    dispatch(clearAuthorization());
  },
});

class Login extends Component {
  state = { email: '', password: '', error: false, loading: false };

  componentDidMount = () => {
    const { clearAuthorization } = this.props;
    clearAuthorization();
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSignIn = () => {
    const { client, saveAuthorization, history, location } = this.props;
    const { email, password } = this.state;
    this.setState({ loading: true });
    client
      .mutate({
        mutation: SigninUser,
        variables: {
          credentials: {
            email,
            password,
          },
        },
      })
      .then(({ data }) => {
        this.setState({ loading: false });
        const token = data.signinUser.token.id;
        const role = data.signinUser.user.role;
        saveAuthorization(token, role);
        history.push(location.state ? location.state.from : '/');
      })
      .catch((error) => this.setState({ error: true, loading: false }));
  };

  render = () => (
    <View
      {...this.state}
      onChange={this.handleChange}
      onSignIn={this.handleSignIn}
    />
  );
}

export default connect(null, mapDispatchToProps)(withApollo(Login));



// WEBPACK FOOTER //
// ./src/component/LoginPage/index.js